import { ONBOARDING_VERSION_ENUM, type OnboardingType } from '@/stores/companySettings'

export const isOnboardingType = (value: unknown): value is OnboardingType => {
  if (!value || typeof value !== 'object') return false
  const { version, steps } = value as Record<string, unknown>

  if (
    !Object.values(ONBOARDING_VERSION_ENUM).includes(version as ONBOARDING_VERSION_ENUM) ||
    !steps ||
    typeof steps !== 'object'
  )
    return false

  const onboardingSteps = steps as Record<string, unknown>
  return (
    typeof onboardingSteps.add_domain_name === 'boolean' &&
    typeof onboardingSteps.add_collaborator === 'boolean' &&
    typeof onboardingSteps.upload_travel_policies === 'boolean'
  )
}
